import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

import { DesignToken } from "@livechat/design-system-react-components";

import LinkStyledButton from "components/button/LinkStyledButton";
import { withVar } from "themes/helpers";

export const SectionWrapper = styled.div`
  border-top: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};

  > div {
    border: none;
    margin: 0px;

    > div {
      font-size: 16px;
    }

    div:nth-of-type(2) {
      > div {
        padding-top: 0;
      }
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  font-weight: 600;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
  margin-bottom: 8px;
`;

export const StyledTitle = styled.div`
  flex: 1;
  font-size: 14px;
`;

export const StyledTicketLink = styled(Link)`
  position: relative;
  top: 2px;
  margin-left: 4px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.linkColor
  };
  word-break: break-word;
  text-decoration: none;
`;

export const StyledLinkContainer = styled.div`
  margin: 10px 0;
`;

export const StyledLink = styled(LinkStyledButton)`
  margin-left: 10px;
  font-size: 14px;
  font-weight: normal;

  &:hover,
  &:active {
    text-decoration: none;
  }
`;

export const EmptySubject = styled.span`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor50
  };
`;

export const upgradeImgStyles = css`
  position: relative;
  top: 5px;
  margin-bottom: 15px;
`;

export const upgradeInlineIconStyles = css`
  right: 2px;
  position: relative;
`;

export const upgradeTooltipStyles = css`
  max-width: 280px;
`;
